import {
    URLAPI,
    REASON_DECLINE_PATH,
    REASON_DECLINE_CREATE_PATH,
    REASON_DECLINE_UPDATE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_reason_decline: {
        data: [],

        status: 0,
        message: {},
    },

    _create_reason_decline: {
        data: {},
        status: 0,
        message: {},
    },
    _update_reason_decline: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_REASON_DECLINE = "GET_ALL_REASON_DECLINE";
export const CREATE_REASON_DECLINE = "CREATE_REASON_DECLINE";
export const UPDATE_REASON_DECLINE = "UPDATE_REASON_DECLINE";

export const reason_decline_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_REASON_DECLINE:
            return {
                ...state,
                _get_all_reason_decline: action.payload,
            };
        case CREATE_REASON_DECLINE:
            return {
                ...state,
                _create_reason_decline: action.payload,
            };
        case UPDATE_REASON_DECLINE:
            return {
                ...state,
                _update_reason_decline: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllReasonDecline = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${REASON_DECLINE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_REASON_DECLINE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_REASON_DECLINE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_REASON_DECLINE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createReasonDecline = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${REASON_DECLINE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_REASON_DECLINE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_REASON_DECLINE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_REASON_DECLINE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateReasonDecline = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${REASON_DECLINE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_REASON_DECLINE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_REASON_DECLINE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_REASON_DECLINE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_reason_decline = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
